/**
 * Lo que ocupan las dos ventanas de Trabajadores y servicios.
 * Es de quien mira, no del negocio.
 */
export const CLAVE_PANELES = 'agendify.catalogo.paneles'

export const ANCHO_MIN = 25
export const ANCHO_MAX = 75
export const ALTO_MIN = 120
export const ALTO_MAX = 520
export const ANCHO_DEF = 50
export const ALTO_DEF = 224

export type PanelesCatalogo = { anchoServicios: number; altoListas: number }

export function pegarAncho(n: number): number {
    return Math.round(Math.min(ANCHO_MAX, Math.max(ANCHO_MIN, n)))
}

export function pegarAlto(n: number): number {
    return Math.round(Math.min(ALTO_MAX, Math.max(ALTO_MIN, n)))
}

export function anchoDesdeX(x: number, left: number, width: number): number {
    if (width <= 0) return ANCHO_DEF
    return pegarAncho(((x - left) / width) * 100)
}

export function altoDesdeDelta(inicial: number, deltaY: number): number {
    return pegarAlto(inicial + deltaY)
}

const DEFECTO: PanelesCatalogo = { anchoServicios: ANCHO_DEF, altoListas: ALTO_DEF }

export function leerPaneles(): PanelesCatalogo {
    try {
        const g = localStorage.getItem(CLAVE_PANELES)
        if (!g) return { ...DEFECTO }
        const o = JSON.parse(g) as Partial<PanelesCatalogo>
        return {
            anchoServicios: pegarAncho(Number(o.anchoServicios) || ANCHO_DEF),
            altoListas: pegarAlto(Number(o.altoListas) || ALTO_DEF),
        }
    } catch {
        return { ...DEFECTO }
    }
}

export function recordarPaneles(p: PanelesCatalogo): void {
    try {
        localStorage.setItem(
            CLAVE_PANELES,
            JSON.stringify({
                anchoServicios: pegarAncho(p.anchoServicios),
                altoListas: pegarAlto(p.altoListas),
            }),
        )
    } catch {
        /* modo privado */
    }
}
